import { cn } from "@/utils/helpers";
import { ReactNode } from "react";
import { Card } from "../ui/card";

type BaseProps = {
  className?: string;
  children: ReactNode;
};

export function CommentContainer({ className, children }: BaseProps) {
  return <Card className={cn("flex cursor-auto gap-3 border-0 px-3 py-2 shadow-none", className)}>{children}</Card>;
}

export function CommentProfileImageArea({ className, children }: BaseProps) {
  return <div className={cn("", className)}>{children}</div>;
}

export function CommentContentArea({ className, children }: BaseProps) {
  return <div className={cn("relative flex w-full flex-col gap-1 text-sm", className)}>{children}</div>;
}

export function CommentHeader({ className, children }: BaseProps) {
  return <div className={cn("flex items-center justify-between", className)}>{children}</div>;
}

export function CommentInfoHeader({ className, children }: BaseProps) {
  return <div className={cn("flex items-center gap-2 text-muted-foreground", className)}>{children}</div>;
}

export function CommentText({ className, children }: BaseProps) {
  return <p className={cn("", className)}>{children}</p>;
}

export function CommentActionArea({ className, children }: BaseProps) {
  return <div className={cn("mt-4", className)}>{children}</div>;
}
